var apiUrl = '/api/'
/* Mobile Debug */
if (window.location.origin.indexOf('8080') > 0) {
  apiUrl = window.location.origin.replace('8080', '52325') + '/'
  // apiUrl = 'https://apitest.eurekosigorta.com.tr/'
  // apiUrl = 'https://api-prep.eurekosigorta.com.tr/'
}
/* Desktop Debug */
if (window.location.origin.indexOf('8081') > 0) {
  apiUrl = window.location.origin.replace('8081', '52325') + '/'
  // apiUrl = 'https://apitest.eurekosigorta.com.tr/'
  // apiUrl = 'https://api-prep.eurekosigorta.com.tr/'
}
// apiUrl = 'https://apitest.eurekosigorta.com.tr/'
const md5 = require('md5')
var _loadingActive = false
const contentUrl = '/static/content/'
var defaultErrorMessage = 'Özür dileriz, işleminizi gerçekleştiremiyoruz. Size yardımcı olabilmemiz için lütfen +90 (850) 222 66 60 nolu numaradan müşteri iletişim merkezine ulaşınız.'

function stringify (obj) {
  const parts = []

  function iterate (obj, currentKey = '') {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key]
        const newKey = currentKey ? `${currentKey}[${key}]` : key

        if (typeof value === 'object' && !Array.isArray(value)) {
          iterate(value, newKey)
        } else {
          parts.push(`${newKey}=${encodeURIComponent(value)}`)
        }
      }
    }
  }

  iterate(obj)

  return parts.join('&')
}

function showMessage (eventHub, title, message, messageType, hiddenMessage) {
  eventHub.$emit('show-message', {
    title: title,
    message: message,
    messageType: messageType,
    hiddenMessage: hiddenMessage,
    closeTime: 3000
  })
}

function postData (context, eventHub, loadingActive, url, data, autoErrorMessage) {
  loadingActive = loadingActive || _loadingActive
  autoErrorMessage = autoErrorMessage === undefined ? true : autoErrorMessage
  if (loadingActive) {
    eventHub.$emit('before-request')
  }
  if (Object.keys(data).length !== 0) {
    data.Token = window.getToken() || ''
  }
  data.language = context.$i18n.locale.toUpperCase()
  return context.$http.post(url, data)
    .then(function (resp) {
      if (loadingActive) {
        eventHub.$emit('after-response')
      }

      // TODO: Görkemle üstünden geçmeliyiz.
      if (typeof (resp.body) === 'object') {
        var result = JSON.parse(resp.bodyText)
        if (autoErrorMessage && result.ResultType !== 0) {
          defaultErrorMessage = data.language === 'EN' ? 'Sorry, we are unable to process your transaction. Please contact our customer communication center at +90 (850) 222 66 60 to help you.' : 'Özür dileriz, işleminizi gerçekleştiremiyoruz. Size yardımcı olabilmemiz için lütfen +90 (850) 222 66 60 nolu numaradan müşteri iletişim merkezine ulaşınız.'
          var message = (result.ErrorMessage !== null && result.ErrorMessage.length > 0) ? result.ErrorMessage : defaultErrorMessage
          switch (result.ErrorCode) {
            case 100:
              showMessage(eventHub, message, '', 'warning', null)
              break
            case 102:
              showMessage(eventHub, defaultErrorMessage, '', 'warning', message)
              break
            case 103:
              // redirectToHome()
              showMessage(eventHub, defaultErrorMessage, '', 'warning', message)
              break
            case 104:
              // redirectToHome()
              showMessage(eventHub, defaultErrorMessage, '', 'warning', message)
              break
            default:
              var warningText = data.language === 'EN' ? 'Operation Failed' : 'İşlem Başarısız'
              showMessage(eventHub, warningText, message, 'warning')
          }
        }
        if (result.ReturnObject != null && result.ReturnObject.Token != null) {
          var newTokens = result.ReturnObject.Token.split(':')
          var token = window.getToken() || ''
          var tokens = token.split(':')
          if (newTokens.length < 2 && tokens.length === 2) {
            if (url.includes('Access/RefreshToken')) {
              window.setToken([tokens[0], result.ReturnObject.Token].join(':'))
            } else {
              window.setToken([result.ReturnObject.Token, tokens[1]].join(':'))
            }
          } else window.setToken(result.ReturnObject.Token)
        }
      }
      // Global Token Update
      return resp
    }, (err) => {
      if (loadingActive) {
        eventHub.$emit('response-error')
      }
      var message = ''

      // Servis bağlantısı yoksa hata mesajı verilir.
      if (err.status === 0 && err.ok === false) {
        var internetWarningText = data.language === 'EN' ? 'Please check your internet connection!' : 'Lütfen internet bağlantınızı kontrol edin!'
        if (autoErrorMessage) { showMessage(eventHub, internetWarningText, message, 'warning') }
      }

      if (err.status === 500) {
        // var errorMessage = ''
        // var errorTime = new Date().toLocaleString()

        // if (err.bodyText && JSON.parse(err.bodyText)) {
        //   var resInternalError = JSON.parse(err.bodyText)
        //   errorMessage = err.url + resInternalError.status + '<br>' + resInternalError.ReturnObject
        // } else {
        //   errorMessage = err.url + ' ' + err.status
        // }

        // errorMessage += ' ' + errorTime
        // window.sendClientLog(errorMessage)

        var warningText = data.language === 'EN' ? 'Operation Failed' : 'İşlem Başarısız'
        var error500Msg = data.language === 'EN' ? 'Sorry, we are unable to process your transaction. Please contact our customer communication center at +90 (850) 222 66 60 to help you.' : 'Özür dileriz, işleminizi gerçekleştiremiyoruz. Size yardımcı olabilmemiz için lütfen +90 (850) 222 66 60 nolu numaradan müşteri iletişim merkezine ulaşınız.'
        showMessage(eventHub, warningText, error500Msg, 'warning')

        // if (window.location.pathname !== '/500Error') {
        //   window.location.href = '/500Error'
        // }
      } else if (err.status === 401) {
        return refreshTokenSrv(context, eventHub, loadingActive).then((refreshResult) => {
          if (refreshResult) {
            return postData(context, eventHub, true, url, data, autoErrorMessage)
          } else {
            return logOut(context, eventHub).then((result) => {
              if (result) {
                window.deleteLoginItems()
                window.removeCustomerInfo()
                window.removeAgencyAuthorizationsInfo()
                setTimeout(function () {
                  eventHub.$emit('logout', {
                    value: true
                  })
                }, 1000)
                return false
              }
            })
          }
        })
      }
      if (err.status === 200 && err.bodyText && JSON.parse(err.bodyText)) {
        var res = JSON.parse(err.bodyText)
        message = res.status + '<br>' + res.ReturnObject
      } else {
        message = err.url + ' ' + err.status
      }

      return err
    }).catch((e) => {
      if (loadingActive) {
        eventHub.$emit('response-error')
      }
      var operationWarningText = data.language === 'EN' ? 'Wrong Operation!' : 'Hatalı İşlem!'
      if (autoErrorMessage) { showMessage(eventHub, operationWarningText, e.message, 'warning') }
      return e
    })
}

function getData (context, eventHub, loadingActive, url) {
  loadingActive = loadingActive || _loadingActive
  if (loadingActive) {
    eventHub.$emit('before-request')
  }
  return context.$http.get(url)
    .then(function (resp) {
      if (loadingActive) {
        eventHub.$emit('after-response')
      }

      if (typeof (resp.body) === 'object') {
        var result = JSON.parse(resp.bodyText)
      }

      return result
    }, (_) => {
      if (loadingActive) {
        eventHub.$emit('response-error')
      }
      return null
    })
}

async function logOut (context, eventHub) {
  var request = {
    logOut: true
  }

  var data = await postData(context, eventHub, true, apiUrl + 'Access/Logout', request)
  if (data.body.ResultType === 0) {
    var loginInfo = JSON.parse(data.bodyText)

    if (loginInfo && loginInfo.ResultType === 0) {
      return true
    }
  } else {
    return false
  }
}

async function wait (ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

async function refreshTokenSrv (context, eventHub, loadingActive, retry = false) {
  var refreshRequestCount = retry ? getRefreshTokenCount() : refreshTokenCountPlus()
  // console.log(refreshRequestCount)
  var result = false
  var dateNow = new Date()
  var lastSuccessRefreshTime = window.getLastSuccessRefreshTime() ? Date.parse(window.getLastSuccessRefreshTime()) : null

  if (lastSuccessRefreshTime != null && parseInt((dateNow - lastSuccessRefreshTime) / 60000) > 30) { // 30 dk geçtiyse logout et adamı
    // console.log('30 dk yı aştığı için logout edildi')
    return false
  }

  // eslint-disable-next-line no-unmodified-loop-condition
  if (refreshRequestCount > 1) {
    await wait(3000)
    return refreshTokenSrv(context, eventHub, loadingActive, true)
  } else {
    if (lastSuccessRefreshTime != null && parseInt((dateNow - lastSuccessRefreshTime) / 1000) < 10) {
      refreshTokenCountMinus()
      return true
    }
    var request = {
      refreshToken: window.getRefreshToken()
    }
    if (!window.getToken()) {
      result = false
    } else {
      var data = await postData(context, eventHub, true, apiUrl + 'Access/RefreshToken', request)
      if (data.body.ResultType === 0) {
        var res = JSON.parse(data.bodyText)
        lastSuccessRefreshTime = new Date()
        window.setLastSuccessRefreshTime(lastSuccessRefreshTime)
        window.setRefreshToken(res.ReturnObject.RefreshToken)
        result = true
      } else {
        result = false
      }
      refreshTokenCountMinus()
      return result
    }
  }
}

function getRefreshTokenCount () {
  var count = window.getRefreshRequestCount()
  return (count == null) ? 0 : parseInt(count)
}

function refreshTokenCountPlus () {
  var count = getRefreshTokenCount()
  count++
  window.setRefreshRequestCount(count)
  // localStorage.setItem('refreshRequestCount', count)
  return count
}

function refreshTokenCountMinus () {
  var count = getRefreshTokenCount()
  count--
  window.setRefreshRequestCount(count)
  // localStorage.setItem('refreshRequestCount', count)
  return count
}

// function redirectToHome () {
//   var token = window.getToken()
//   if (token !== null && token.length > 0 && token.split(':').length === 2) {
//     window.setToken(token.split(':')[0])
//   }
//   window.location.href = '/'
// }

export default {
  // User object will let us check authentication status
  user: {
    authenticated: false
  },
  apiUrl: function () {
    return apiUrl
  },
  /* Claim */
  claim: {
    cities (context, eventHub, loadingActive) {
      return postData(context, eventHub, loadingActive, apiUrl + 'ClaimServiceList/GetCityList', {})
    },
    brands (context, eventHub, loadingActive) {
      return postData(context, eventHub, loadingActive, apiUrl + 'ClaimServiceList/GetBrands', {})
    },
    counties (context, eventHub, loadingActive, cityCode) {
      return postData(context, eventHub, loadingActive, apiUrl + 'ClaimServiceList/GetCountyList', { 'cityCode': cityCode })
    },
    search (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/Search', data)
    },
    detail (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/Detail', data)
    },
    claimServiceList (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/ClaimServiceList', data)
    },
    claimControl (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/ClaimControl', data)
    },
    nonAutoClaimCreate (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/NonAutoClaimCreate', data)
    },
    autoClaimCreate (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/AutoClaimCreate', data)
    },
    claimPaymentList (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/ClaimPaymentList', data)
    },
    claimLossReasonList (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/ClaimLossReasonList', data)
    },
    cityCountyList (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/CityCountyList', data)
    },
    missingDocList (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/MissingDocList', data)
    },
    missingDocUpdate (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/MissingDocUpdate', data)
    },
    claimInquery (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/ClaimInquery', data)
    },
    searchPolicy (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/SearchPolicy', data)
    },
    checkProviderValid (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/CheckProviderValid', data)
    },
    uploadClaimDocuments (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/UploadClaimDocuments', data)
    },
    reportTypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Claim/GetReportTypes', data)
    }
  },
  search: function (context, eventHub, loadingActive, query) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Search/Query', { query: query })
  },
  /* Providers */
  providers: {
    GetPartners (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/PartnerList', data)
    },
    GetPartnerTypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetPartnerTypes', data)
    },
    GetCities (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetCities', data, false)
    },
    GetDistricts (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetDistricts', data)
    },
    GetAutoServiceAttributes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetAutoServiceAttributes', data)
    },
    GetAutoBrands (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetAutoBrands', data, false)
    },
    GetAutoTypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetAutoTypes', data, false)
    },
    GetMedicalTypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetMedicalTypes', data, false)
    },
    GetMedicalTypeNames (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetMedicalTypeNames', data, false)
    },
    GetMedicalNetworktypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetMedicalNetworktypes', data)
    },
    GetDoctorSpecialities (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Provider/GetDoctorSpecialities', data)
    }
  },
  /* Parameter */
  parameter: {
    addressDetail (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/AddressDetail', data)
    },
    formCities (context, eventHub, loadingActive) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/GetFormCities', {})
    },
    cities (context, eventHub, loadingActive) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/Cities', {})
    },
    daskCities (context, eventHub, loadingActive) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/DaskCities', {})
    },
    counties (context, eventHub, loadingActive, cityCode) {
      var data = {
        id: cityCode
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/Districts', data)
    },
    daskCounties (context, eventHub, loadingActive, cityCode) {
      var data = {
        id: cityCode
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/DaskDistricts', data)
    },
    subDistricts (context, eventHub, loadingActive, city, district) {
      var data = {
        id: city,
        subId: district
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/SubDistricts', data)
    },
    neighborhoods (context, eventHub, loadingActive, city, subDistrict) {
      var data = {
        id: city,
        subId: subDistrict
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/Neighborhoods', data)
    },
    streets (context, eventHub, loadingActive, neighborhood) {
      var data = {
        id: neighborhood
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/Streets', data)
    },
    buildings (context, eventHub, loadingActive, neighborhood, street) {
      var data = {
        id: neighborhood,
        subId: street
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/Buildings', data)
    },
    flats (context, eventHub, loadingActive, building) {
      var data = {
        id: building
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/Flats', data)
    },
    vehicleUsageTypes (context, eventHub, loadingActive, productName) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/' + productName + '/VehicleUsageType', {})
    },
    brands (context, eventHub, loadingActive, productName, vehicleUsageType) {
      var data = {
        id: vehicleUsageType
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/' + productName + '/VehicleBrands', data)
    },
    modelYears (context, eventHub, loadingActive, productName, vehicleUsageType, vehicleBrand, isNewVehicle) {
      var data = {
        id: vehicleUsageType,
        subId: vehicleBrand,
        subId2: isNewVehicle
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/' + productName + '/VehicleModelYears', data)
    },
    models (context, eventHub, loadingActive, productName, vehicleUsageType, vehicleBrand, vehicleModelYear) {
      var data = {
        id: vehicleUsageType,
        subId: vehicleBrand,
        subId2: vehicleModelYear
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/' + productName + '/VehicleModels', data)
    },
    maxSeatCount (context, eventHub, loadingActive, vehicleType) {
      var data = {
        id: vehicleType
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Parameter/MaxSeatCount', data)
    }
  },
  /* Traffic */
  traffic: {
    checkCustomer (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Traffic/CheckCustomer', data)
    },
    validateSMSCode (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Traffic/ValidateSMSCode', data)
    },
    getVehicleDetail (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Traffic/GetVehicleDetail', data)
    },
    createProposal (context, eventHub, loadingActive, car) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Traffic/CreateProposal', car)
    }
  },
  /* Ferdi kaza */
  personalAccident: {
    checkCustomer (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'PersonalAccident/CheckCustomer', data)
    },
    validateSMSCode (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'PersonalAccident/ValidateSMSCode', data)
    },
    getQuotation (context, eventHub, loadingActive, data) {
      data.Token = ''
      return postData(context, eventHub, loadingActive, apiUrl + 'PersonalAccident/GetQuotation', data)
    },
    createProposal (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'PersonalAccident/CreateProposal', data)
    }
  },
  /* Seyahat */
  travel: {
    checkCustomer (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Travel/CheckCustomer', data)
    },
    validateSMSCode (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Travel/ValidateSMSCode', data)
    },
    getQuotation (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Travel/GetQuotation', data)
    },
    createProposal (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Travel/CreateProposal', data)
    }
  },
  /* Dask */
  dask: {
    checkCustomer (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/CheckCustomer', data)
    },
    validateSMSCode (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/ValidateSMSCode', data)
    },
    addInsured (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/AddInsured', data)
    },
    checkAdditionalPersonIdentity (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/CheckAdditionalPersonIdentity', data)
    },
    getAddressDetail (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/GetAddressDetail', data)
    },
    createProposal (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/CreateProposal', data)
    },
    getQuotation (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/GetQuotation', data)
    },
    renewOldPolicy (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/RenewOldPolicy', data)
    },
    getBuildingUsageTypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/GetBuildingUsageTypes', data)
    },
    getBuildingConstructionTypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/GetBuildingConstructionTypes', data)
    },
    getBuildingConstructionDates (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/GetBuildingConstructionDates', data)
    },
    getBuildingFloorCounts (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Dask/GetBuildingFloorCounts', data)
    }
  },
  /* Kasko */
  motor: {
    checkCustomer (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Motor/CheckCustomer', data)
    },
    validateSMSCode (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Motor/ValidateSMSCode', data)
    },
    getVehicleDetail (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Motor/GetVehicleDetail', data)
    },
    createProposal (context, eventHub, loadingActive, obj) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Motor/CreateProposal', obj)
    }
  },
  /* Tamamlayıcı sağlık */
  supplementalHealth: {
    checkCustomer (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'SupplementalHealth/CheckCustomer', data)
    },
    validateSMSCode (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'SupplementalHealth/ValidateSMSCode', data)
    },
    checkAdditionalPersonIdentity (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'SupplementalHealth/CheckAdditionalPersonIdentity', data)
    },
    getCustomerDetail (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'SupplementalHealth/GetCustomerDetail', data)
    },
    createProposal (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'SupplementalHealth/CreateProposal', data)
    }
  },
  /* 4 mevsim */
  fourSeasonsHealth: {
    checkCustomer (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'FourSeasonsHealth/CheckCustomer', data)
    },
    validateSMSCode (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'FourSeasonsHealth/ValidateSMSCode', data)
    },
    createProposal (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'FourSeasonsHealth/CreateProposal', data)
    }
  },
  /* Konut */
  home: {
    checkCustomer (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Home/CheckCustomer', data)
    },
    validateSMSCode (context, eventHub, loadingActive, data) {
      data.Source = window.location.href
      return postData(context, eventHub, loadingActive, apiUrl + 'Home/ValidateSMSCode', data)
    },
    addInsured (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Home/AddInsured', data)
    },
    getAddressDetail (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Home/GetAddressDetail', data)
    },
    getQuotation (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Home/GetQuotation', data)
    },
    createProposal (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Home/CreateProposal', data)
    },
    getCoverageTypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Home/CoverageTypes', data)
    },
    getBuildingConstructionTypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Home/GetBuildingConstructionTypes', data)
    },
    getUsageTypes (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Home/GetUsageTypes', data)
    }
  },
  access: {
    getPhone: function (context, eventHub, loadingActive, data) {
      const moment = md5(new Date().getTime())
      return postData(context, eventHub, loadingActive, apiUrl + `Access/GetPhone?moment=${moment}`, data, defaultErrorMessage)
    },
    checkPhone: function (context, eventHub, loadingActive, data, defaultErrorMessage) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/CheckPhone', data, defaultErrorMessage)
    },
    checkSmsCode: function (context, eventHub, loadingActive, data, defaultErrorMessage) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/CheckSmsCode', data, defaultErrorMessage)
    },
    login: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/Login', data)
    },
    logOut: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/Logout', data)
    },
    resetPassword: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/ResetPassword', data)
    },
    updatePassword: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/UpdatePassword', data)
    },
    createPassword: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/CreatePassword', data)
    },
    tokenCheck: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/CheckToken', data)
    },
    updateToken: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/UpdateToken', data)
    },
    refreshToken: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/RefreshToken', data)
    },
    refreshTokenCheck (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Access/RefreshTokenCheck', data)
    }
  },
  customer: {
    policies: function (context, eventHub, loadingActive, data, defaultErrorMessage) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/Policies', data, defaultErrorMessage)
    },
    getPolicyList: function (context, eventHub, loadingActive, data, defaultErrorMessage) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetPolicyList', data, defaultErrorMessage)
    },
    getGetPolicyListHasAuthorization: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetPolicyListHasAuthorization', data)
    },
    getPolicy: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/Policy', data)
    },
    detail: function (context, eventHub, loadingActive, data, defaultErrorMessage) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/Detail', data, defaultErrorMessage)
    },
    update: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/Update', data)
    },
    addDetail: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/AddDetail', data)
    },
    deletePersonalInfo: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/DeletePersonalInfo', data)
    },
    search: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/Search', data)
    },
    proposalToPolicy: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/ProposalToPolicy', data)
    },
    cancelPolicy: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/CancelPolicy', data)
    },
    setCustomerConnectionPreferences: function (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/SetCustomerConnectionPreferences', data)
    },
    getCustomerConnectionPreferences: function (context, eventHub, loadingActive, data, defaultErrorMessage) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetCustomerConnectionPreferences', data, defaultErrorMessage)
    },
    sendNPS (context, eventHub, loadingActive, data, productId) {
      return postData(context, eventHub, loadingActive, apiUrl + productId + '/AddNPS', data)
    },
    getPaymentPlan (context, eventHub, loadingActive, data, defaultErrorMessage) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetPaymentPlan', data, defaultErrorMessage)
    },
    getRemainingLimit (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetRemainingHealthLimit', data)
    },
    getPersonsClaimList (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetPersonsClaim', data)
    },
    getCustomerDocuments (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetCustomerFiles', data)
    },
    getPaymentInformation (context, eventHub, loadingActive, data, defaultErrorMessage) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetPolicyReceiptDetail', data, defaultErrorMessage)
    },
    getVgbPolicies (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetVgbPolicies', data, defaultErrorMessage)
    },
    getMissingDocuments (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetMissingDocuments', data, defaultErrorMessage)
    },
    checkCustomerInfo (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/CheckCustomerInfo', data, defaultErrorMessage)
    },
    CheckCustomerCompulsoryFields (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/CheckCustomerCompulsoryFields', data, defaultErrorMessage)
    },
    trace (context, eventHub) {
      return getData(context, eventHub, false, apiUrl + 'Customer/trace')
    },
    getRenewalProposal (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetRenewalProposals', data, defaultErrorMessage)
    },
    setRenewalProposal (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/SetRenewalProposalStatus', data, defaultErrorMessage)
    },
    saveInvoice (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/SaveInvoice', data)
    },
    getInvoiceList (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/HealthInvoiceTrack', data)
    },
    addCreditCard (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/AddCreditCard', data)
    },
    getPaymentMethod (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetPaymentMethod', data)
    },
    getAgencyProductionInfo (context, eventHub, loadingActive, data) {
      if (data.IsIndependent) {
        return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetAgencyProductionInfo', data)
      } else {
        return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetAgencyCumulativeProductionInfo', data)
      }
    },
    getAgencyProductionSummaryInfo (context, eventHub, loadingActive, data) {
      if (data.IsIndependent) {
        return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetAgencyDashboardIndependent', data)
      } else {
        return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetAgencyDashboardCumulative', data)
      }
      // return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetAgencyProductionSummaryInfoData', data)
    },
    getAgencyBranchesAndTermsData (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetAgencyBranchesAndTermsData', data)
    },
    getAgencyPolicies (context, eventHub, loadingActive, data) {
      var serviceUrl = data.IsRenewal ? 'Customer/RetrieveAgencyRenewalList' : 'Customer/RetrieveAgencyPolicyList'
       return postData(context, eventHub, loadingActive, apiUrl + serviceUrl, data)
    },
    getAgencyPolicyTerms (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/RetrieveAgencyPolicyTermInfo', data)
    },
    getAgencyGetNotificationStatus (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/GetNotificationStatus', data)
    },
    addAgencyGetNotificationStatus (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/AddNotificationStatus', data)
    },
    getAgencyAuthorizations (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Customer/AgencyAuthorization', data)
    }
  },
  payment: {
    makePayment (context, eventHub, loadingActive, data, productId) {
      return postData(context, eventHub, loadingActive, apiUrl + productId + '/MakePayment', data)
    },
    getInstallments (context, eventHub, loadingActive, data, productId) {
      return postData(context, eventHub, loadingActive, apiUrl + productId + '/GetInstallments', data)
    },
    renewalPolicy (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Payment/RenewalPolicy', data)
    }
  },
  documents: {
    getPolicy (context, eventHub, loadingActive, data) {
      // Fake user agent to solve download document problem
      navigator.__defineGetter__('userAgent', function () {
        return 'Mozilla/5.0 (Windows NT 6.2; WOW64; rv:28.0) Gecko/20100101 Firefox/28.0)'
      })
      navigator.__defineGetter__('appName', function () {
        return 'Netscape'
      })
      var form = document.createElement('form')
      form.setAttribute('method', 'POST')
      form.setAttribute('action', apiUrl + 'PostDocument/Policy')
      form.setAttribute('target', '_blank')

      data.Token = window.getToken()
      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          var input = document.createElement('input')
          input.type = 'hidden'
          input.name = i
          input.value = data[i]
          form.appendChild(input)
        }
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    },
    getPolicyWithoutLogin (context, eventHub, loadingActive, data) {
      // Fake user agent to solve download document problem
      navigator.__defineGetter__('userAgent', function () {
        return 'Mozilla/5.0 (Windows NT 6.2; WOW64; rv:28.0) Gecko/20100101 Firefox/28.0)'
      })
      navigator.__defineGetter__('appName', function () {
        return 'Netscape'
      })
      var form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute('action', apiUrl + 'Document/Policy')
      form.setAttribute('target', '_blank')

      data.Token = window.getToken()
      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          var input = document.createElement('input')
          input.type = 'hidden'
          input.name = i
          input.value = data[i]
          form.appendChild(input)
        }
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    },
    getPolicy2 (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'PostDocument/Policy', data)
    },
    healthExpenseForm (context, eventHub, loadingActive, data) {
      var form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute('action', apiUrl + 'PostDocument/HealthExpenseForm')
      form.setAttribute('target', '_blank')

      data.Token = window.getToken()
      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          var input = document.createElement('input')
          input.type = 'hidden'
          input.name = i
          input.value = data[i]
          form.appendChild(input)
        }
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    },
    consulateForm (context, eventHub, loadingActive, data) {
      var form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute('action', apiUrl + 'Customer/GetConsulateForm')
      form.setAttribute('target', '_blank')

      data.Token = window.getToken()
      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          var input = document.createElement('input')
          input.type = 'hidden'
          input.name = i
          input.value = data[i]
          form.appendChild(input)
        }
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    },
    sendHealthExpenseForm (context, eventHub, loadingActive, data, defaultErrorMessage) {
      return postData(context, eventHub, loadingActive, apiUrl + 'PostDocument/SendHealthExpenseForm', data, defaultErrorMessage)
    },
    addDocument (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Document/AddDocument', data)
    },
    policyFileInsert (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Document/PolicyFileInsert', data)
    },
    addClaimMissingDoc (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Document/AddClaimMissingDocuments', data)
    },
    receiptInfo (context, eventHub, loadingActive, data) {
      var form = document.createElement('form')
      form.setAttribute('method', 'post')
      form.setAttribute('action', apiUrl + 'Document/Receipt')
      form.setAttribute('target', '_blank')

      for (var i in data) {
        if (data.hasOwnProperty(i)) {
          var input = document.createElement('input')
          input.type = 'hidden'
          input.name = i
          input.value = data[i]
          form.appendChild(input)
        }
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    }
  },
  content: {
    getAffinity: async function (self) {
      var hostnames = ['localhost', 'testv2.eurekosigorta.com.tr', 'mtestv2.eurekosigorta.com.tr', 'testv3.eurekosigorta.com.tr', 'mtestv3.eurekosigorta.com.tr', 'beta.eurekosigorta.com.tr', 'mbeta.eurekosigorta.com.tr', 'test.eurekosigorta.com.tr', 'mtest.eurekosigorta.com.tr', 'www.eurekosigorta.com.tr']
      if (hostnames.includes(window.location.hostname)) { return null }
      var request = {
        query: 'query affinities($Domain:String){ affinities (where:{Domain: $Domain, Status: true}){ Title Logo {name hash ext} } } ',
        variables: '{ "Domain": "' + window.location.hostname + '"' + '}'
      }
      var service = this
      return service.static(self, self.eventHub, true, request).then(function (response) {
        if (response === null) return

        if (response.data.affinities.length > 0) {
          var data = response.data.affinities[0]
          return { title: data.Title, url: service.contentUrl(data.Logo.ext, data.Logo.hash) }
        } else {
          return { title: '', url: '' }
        }
      })
    },
    products (self, resultObject, cache = true) {
      resultObject = resultObject || 'Title, LongTitle, Description, IconClass, Path, Sale, CanBeProposal, CanBePolicy'

      var request = { query: '{ products (sort: "Order", where: {Status: true, Type: "Bireysel", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){ ' + resultObject + ' } }' }

      return this.static(self, self.eventHub, true, request, cache)
    },
    renewalProducts (self, resultObject, cache = true) {
      resultObject = resultObject || 'Title, LongTitle, Description, IconClass, Path, Sale, CanBeProposal, CanBePolicy'

      var request = { query: '{ products (sort: "Order", where: {Status: true, Type: "Yenileme", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){ ' + resultObject + ', ProductCode } }' }

      return this.static(self, self.eventHub, true, request, cache)
    },
    footers (self) {
      var request = { query: '{ footermenus (where: {IsRoot: true, Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ' }){ Title IconClass Menus (where: {Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ' }){ Title Url }}}' }
      return this.static(self, self.eventHub, true, request)
    },
    desktopMenus (self) {
      var request = { query: '{menus (where: {IsRoot :true, Status: true, HideDesktop: false, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ' }, sort: "Order" ) {Title Url Menus (where: {Status: true, HideDesktop: false, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ' }, sort:"Order"){Title Menus (where: {Status: true, HideDesktop: false, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ' }, sort: "Order") { Title Url }}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    mobileMenus (self) {
      var request = { query: '{menus (where: {Status: true, IsRoot: true, HideMobile:false, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}, sort: "Order"){Title,Menus (where: {Status: true, HideMobile:false, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}, sort: "Order"){Title,Menus (where: {Status: true, HideMobile:false, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}, sort: "Order") {Title Url}}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    productCoverages (self, type) {
      var request = { query: '{products (where: {Type:' + '"' + type + '"' + ', Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', Path: ' + '"' + self.productCode + '"' + '}){Coverages (where: {Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}, sort: "Order"){Title Description }}}' }
      return this.static(self, self.eventHub, true, request)
    },
    productDefinitions (self) {
      var request = { query: '{products (where: {Status: true, Type:"Bireysel", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', Path: ' + '"' + self.productCode + '"' + '}){Definitions (where: {Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title Description ImageClass }}}' }
      return this.static(self, self.eventHub, true, request)
    },
    productsRelatedDocs (self, productType) {
      var request = { query: '{products (where: {Type: ' + '"' + productType + '"' + ', Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', Path: ' + '"' + self.productCode + '"' + '}){Relateddocs (where: {Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title File {hash, ext} }}}' }
      return this.static(self, self.eventHub, true, request)
    },
    productInfoInsurance (self) {
      var request = { query: '{products (where: {Status: true, Type:"Bireysel", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', Path: ' + '"' + self.productCode + '"' + '}){Infoinsurances (where: {Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title InfoInsuranceProductName InfoInsuranceProductUrl }}}' }
      return this.static(self, self.eventHub, true, request)
    },
    productsKnowledgebase (self, productType) {
      var request = { query: '{products (where: {Type: ' + '"' + productType + '"' + ', Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', Path: ' + '"' + self.productCode + '"' + '}){Knowledgebases (where: {Status: true, Language: ' + '"' + self.lang.toUpperCase() + '"' + '}){Title Description }}}' }
      return this.static(self, self.eventHub, true, request)
    },
    faq (self) {
      var request = { query: '{ faqs (where: { Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}) { Title Description } }' }
      return this.static(self, self.eventHub, true, request)
    },
    faqForCategory (self, category) {
      var request = { query: '{ faqs (where: {Tag: ' + '"' + category + '"' + ', Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}) { Title Description } }' }
      return this.static(self, self.eventHub, true, request)
    },
    cookies (self) {
      var request = { query: '{pagecategories (where: {key:"legalInfo", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages {Title Body}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    informations (self) {
      var request = { query: '{pagecategories (where: {key:"legalInfo", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages (where: {Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title Body}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    kvkk (self) {
      var request = { query: '{pagecategories (where: {key:"legalInfo", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages {Title Body}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    arabuluculuk (self) {
      var request = { query: '{pagecategories (where: {key:"legalInfo", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages {Title Body}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    userAgreement (self) {
      var request = { query: '{pagecategories (where: {key:"legalInfo", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages {Title Body}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    query (self) {
      var request = { query: '{pagecategories (where: {key:"legalInfo", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages {Title Body}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    damageProducts (self, cache) {
      var request = { query: '{ damageproducts (sort: "Order", where: {Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}) { _id Title } }' }
      return this.static(self, self.eventHub, true, request, cache)
    },
    damageTypes (self, cache) {
      var request = { query: '{ damageproducts(sort: "Order", where: {_id: ' + '"' + self.questions.product.value + '"' + ', Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title damagetypes (where:{Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){_id Title Description }}}' }
      return this.static(self, self.eventHub, true, request, cache)
    },
    damageTypesDescription (self, cache) {
      var request = { query: '{ damageproducts (where: {_id: ' + '"' + self.questions.product.value + '"' + ', Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title damagetypes (where: {Title: ' + '"' + self.questions.damageType.value + '"' + ', Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title Description HasLegalCase }}}' }
      return this.static(self, self.eventHub, true, request, cache)
    },
    damageTypesHasLegalCase (self, cache) {
      var request = { query: '{ damagetypes (sort: "Order", where: {_id: ' + '"' + self.questions.damageType.value + '"' + ', Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', Status: true}){damagedocuments (where: { Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', Status: true IsLegalCase: true }){Title _id}}}' }
      return this.static(self, self.eventHub, true, request, cache)
    },
    damageDocuments (self, cache) {
      var request = { query: '{ damagetypes (sort: "Order", where: {_id: ' + '"' + self.questions.damageType.value + '"' + ', Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', Status: true}){damagedocuments (where: { Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', Status: true IsLegalCase: false }){Title _id}}}' }
      return this.static(self, self.eventHub, true, request, cache)
    },
    eurekoServices (self, key) {
      var request = { query: '{pagecategories (where: {key: ' + '"' + key + '"' + ', Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages {Title, Body, seoDescription, seoTag , seoTitle}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    announcements (self) {
      var request = { query: '{announcements (where: {Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}, sort: "Order") {Title Url {ext hash}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    newsletters (self) {
      var request = { query: '{newsletters (where: {Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ' }, sort: "OrderNo:DESC") {Title, Document {ext, hash}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    headquarters (self) {
      var request = { query: '{pagecategories (where: {key:"pressRoom", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages (where: {Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title Body}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    aboutPage (self) {
      var request = { query: '{pagecategories (where: {key: "eurekoCorporate", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages (where: {Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title Body}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    sustainabilityPage (self) {
      var request = { query: '{pagecategories (where: {key: "sustainability", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages (where: {Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title Body}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    careerPage (self) {
      var request = { query: '{pagecategories (where: {key: "career", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages (where: {Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title, Body, seoUrl, seoDescription, seoTag, seoTitle}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    socialResponsibilityPage (self) {
      var request = { query: '{pagecategories (where: {Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', key: "socialResponsibility"}){Title pages (where:{Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title, Body, seoUrl, seoDescription, seoTag, seoTitle}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    customerSatisfactionPage (self) {
      var request = { query: '{ pagecategories (where: {Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + ', key: "customerSatisfaction", Status: true}){ Title pages (where: {Status: true, Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){ Title Body } } }' }
      return this.static(self, self.eventHub, true, request)
    },
    corporateProducts (self, resultObject) {
      resultObject = resultObject || 'Title, LongTitle, IconClass, Path'

      var request = { query: '{ products (sort: "Order", where: {Status: true, Type: "Kurumsal", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){ ' + resultObject + ' } }' }

      return this.static(self, self.eventHub, true, request)
    },
    allCorporateProducts (self, resultObject) {
      resultObject = resultObject || 'Title, LongTitle, IconClass, Path'

      var request = { query: '{ products (sort: "Order", where: {Type: "Kurumsal", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){ ' + resultObject + ' } }' }

      return this.static(self, self.eventHub, true, request)
    },
    mobileApp (self) {
      var request = { query: '{pagecategories (where: {key:"mobileApp", Language: ' + '"' + self.$i18n.locale.toUpperCase() + '"' + '}){Title pages {Title Body Images{hash ext }}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    garantiLandingKnowledgebases (self) {
      var request = { query: '{garantilandingknowledgebases (where: {Status: true}){Title, Description}}' }
      return this.static(self, self.eventHub, true, request)
    },
    garantiLandingAdvantages (self) {
      var request = { query: '{garantilandingadvantages (where: {Status: true}){Title, IconClass}}' }
      return this.static(self, self.eventHub, true, request)
    },
    garantiLandingpages (self) {
      var request = { query: '{garantilandingpages (where: {Status: true}){Title,Description,Banner{hash,name,ext}}}' }
      return this.static(self, self.eventHub, true, request)
    },
    onlineBranchUrls (self) {
      var request = { query: '{commonurls (where: {Status: true, Tag: "onlineBranch"}){Name, Url, Key}}' }
      return this.static(self, self.eventHub, true, request)
    },
    campaigns (self, req, cache) {
      var request = {
        query: '{campaigns (where: {Status: true, CampaignTitle:' + '"' + req.campaignId + '"' + '}){Title,CampaignTitle,Description,DescriptionTitle,Subtitle,StartDate,EndDate,StickyHeaderText,GreenButtonStatus,WhiteButtonStatus,' +
          'GreenButtonText,WhiteButtonText,DescriptionBulletItem,BannerUrl,GreenButtonUrl,WhiteButtonUrl,DateIntervalStatus,HasBannerOverlay,Banner{hash,name,ext},MobileBanner{hash,name,ext}}}'
      }
      return this.static(self, self.eventHub, true, request, cache)
    },
    campaignKnowledgebase (self, req, cache) {
      // var request = { query: '{campaigns (where: {Status: true, _id:' + '"' + req.campaignId + '"' + '}){Campaignknowledgebase {Title, Description}}}' }
      var request = { query: '{campaigns (where: {Status: true, CampaignTitle:' + '"' + req.campaignId + '"' + '}){campaignknowledgebases (where: {Status: true}){Title Description }}}' }
      return this.static(self, self.eventHub, true, request, cache)
    },
    agencyForms (self, req, cache) {
      var query = stringify(
      {
        fields: ['Name', 'createdAt', 'status', 'Otomativ', 'Acente', 'DogusKurumsalAcenteBroker'],
        populate: {
          Attachment: {
            fields: ['ext', 'hash']
          }
        },
        publicationState: 'live'
      },
      {
        encodeValuesOnly: true
      }
    )
    var body = {
      query: 'api/agency-forms?' + query,
      cache: false
    }
      return this.static(self, self.eventHub, true, body, false)
    },
    agencyEducations (self, req, cache) {
      var query = stringify(
      {
        fields: ['Name', 'createAt', 'type', 'Otomativ', 'Acente', 'DogusKurumsalAcenteBroker'],
        populate: {
          Attachment: {
            fields: ['ext', 'hash']
          }
        },
        publicationState: 'live'
      },
      {
        encodeValuesOnly: true
      }
      )
      var body = {
        query: 'api/agency-learnings?' + query,
        cache: false
      }
      return this.static(self, self.eventHub, true, body, false)
    },
    agencyAnnouncements (self, req, cache) {
      var query = stringify(
      {
        fields: ['Title', 'Description', 'IsImportant', 'Status', 'createAt', 'Otomativ', 'Acente', 'DogusKurumsalAcenteBroker'],
        populate: {
          Attachment: {
            fields: ['ext', 'hash']
          }
        },
        publicationState: 'live'
      },
      {
        encodeValuesOnly: true
      }
      )
      var body = {
        query: 'api/agency-announcements?' + query,
        cache: false
      }
      return this.static(self, self.eventHub, true, body, false)
    },
    static: async function (context, eventHub, loadingActive, data, cache = true) {
      data.cache = cache
      var hash = context.hash(data.query)
      // var time = new Date().getTime()
      if (cache) {
        var storageContent = localStorage.getItem(hash)
        if (storageContent !== null) {
          var splitedData = storageContent.split('||')
          var recordTime = Number(splitedData[0])
          if ((recordTime + (60 * 60 * 1000)) >= new Date().getTime()) {
            var contentJson = storageContent.replace(recordTime + '||', '')
            return JSON.parse(contentJson)
          }
        }
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Content/static/V2', data, false).then(function (response) {
        if (!response.body.ReturnObject.data.length) { return null }
        var returnObject = response.body.ReturnObject.data
        // var returnObject = JSON.parse(response.body.ReturnObject.data)
        // if (cache) {
        //   localStorage.setItem(hash, time + '||' + response.body.ReturnObject.data)
        // }
        return returnObject
      }).catch(function () {
        return context.$resource(contentUrl + 'cms/' + hash + '.json').get().then(function (resJson) {
          if (resJson.status === 200 && resJson.bodyText.length) {
            return JSON.parse(resJson.bodyText)
          } else { return null }
        }).catch(function () { return null })
      })
    },
    contentUrl (ext, hash) {
      return apiUrl + 'Content/assets/V2/' + ext.replace('.', '') + '/' + hash
    },
    getContent (data) {
      var url = apiUrl + 'Content/assets/V2/' + data.extension + '/' + data.filename
      var page = window.open(url)
      page.document.title = data.filename
      return page
    }
  },
  calculator: {
    trafficMinMax (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Calculator/TrafficMinMax', data)
    }
  },
  coverages: {
    static (context, productId) {
      return context.$resource(contentUrl + 'products/' + productId + '/staticCoverage.json').get()
    },
    dynamic (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'Coverage/GetPolicyCoverages', data)
    }
  },
  kvkk: {
    detail (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'KVKK/Detail', data, false)
    },
    sendForm (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'KVKK/SendForm', data, false)
    },
    retrievePermissions (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'KVKK/RetrievePermissions', data, false)
    },
    maintainPermissions (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'KVKK/MaintainPermissions', data, false)
    }
  },
  survey: {
    get (context, eventHub, loadingActive, surveyId) {
      var data = {
        SurveyId: surveyId
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Survey/Get', data)
    },
    send (context, eventHub, loadingActive, surveyId, response) {
      var data = {
        SurveyId: surveyId,
        Response: response
      }
      return postData(context, eventHub, loadingActive, apiUrl + 'Survey/Send', data)
    }
  },
  digitalCampaign: {
    getAllDigitalCampaigns (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'DigitalCampaigns/GetAllDigitalCampaigns', data, false)
    },
    getAllCampaigns (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'DigitalCampaigns/GetAllCampaigns', data)
    },
    getCampaigns (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'DigitalCampaigns/GetCampaigns', data)
    },
    getOldCampaigns (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'DigitalCampaigns/GetOldCampaigns', data)
    },
    getCoupons (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'DigitalCampaigns/GetCoupons', data)
    },
    assignCoupon (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'DigitalCampaigns/AssignCoupon', data)
    }
  },
  blogContent: {
    getBlogPosts (context, eventHub) {
      return getData(context, eventHub, false, apiUrl + 'Blog/GetPosts')
    }
  },
  openLine: {
    complaint (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'OpenLine/Complaint', data, false)
    }
  },
  customerInteraction: {
    checkGuid (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'CustomerInteraction/CheckGuid', data, false)
    },
    saveKVKKConsent (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'CustomerInteraction/SaveKvkkAccess', data, false)
    },
    saveCCResult (context, eventHub, loadingActive, data) {
      return postData(context, eventHub, loadingActive, apiUrl + 'CustomerInteraction/SaveCCAccess', data, false)
    }
  },
  sendValetForm (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/SendValetForm', data)
  },
  sendForgedDamageForm (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/SendForgedDamageForm', data)
  },
  sendExpertApplyForm (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/SendExpertApplyForm', data)
  },
  sendAgencyApplyForm (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/SendAgencyApplyForm', data)
  },
  sendContractedServiceApplyForm (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/SendContractedServiceApplyForm', data)
  },
  sendSurveyForm (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/SendSurveyForm', data)
  },
  sendContactForm (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/SendContactForm', data)
  },
  sendDamageDocuments (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/SendDamageDocuments', data)
  },
  getPhoneNumber (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/CorporatePhoneNumber', data)
  },
  getPhoneForCampaigns (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/CampaignPhoneNumber', data)
  },
  productLeadForm (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/ProductLeadForm', data)
  },
  getHolders (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Financial/GetHolderInfo', data)
  },
  crossSell (context, eventHub) {
    return context.$resource(contentUrl + 'products/crossSell.json').get()
  },
  getNewsImages (context) {
    return context.$resource(contentUrl + 'corporate/news.json').get()
  },
  getPhotographs (context) {
    return context.$resource(contentUrl + 'corporate/photographs.json').get()
  },
  getComplaintReasons (context, eventHub, loadingActive, data) {
    return postData(context, eventHub, loadingActive, apiUrl + 'Form/GetComplaintReasons', data)
  }
}



// WEBPACK FOOTER //
// ./src/service/index.js